import Button from 'components/Button/index'
import Flex from 'components/Flex'
import { Form } from 'components/UIComponents/FormStyles/index'
import CheckedWhite from 'components/icons/CheckedWhite'
import AddtionalInfo from 'modules/Settings/Components/AddtionalInfo/index'
import InstituteInfo from 'modules/Settings/Components/InstituteInfo/index'
import {
  PaddedDiv,
  SectionWrapper,
  StyledTabs,
  TopHeader,
  TopHeading,
} from 'modules/Settings/Styles/style'
import React, { useEffect, useState } from 'react'
import { getYear } from 'utils/getYear'

import { Modal, Tabs } from 'antd'
import TaxInfo from 'modules/Settings/Components/TaxInfo/index'
import moment from 'moment'
import SuccessMessage from 'utils/SuccessMessage'
const { TabPane } = Tabs

import { getInstituteDetails } from 'modules/Auth/actions.js'
import { useDispatch, useSelector } from 'react-redux'
import { permittedCruds } from '../../utils/permissionsValidation'
import { getUniversityList } from './actions'
const { confirm } = Modal

const Settings = ({
  instituteData,
  getInstituteInfo,
  getListOfCities,
  getListOfStates,
  getListOfCountries,
  getUserRoles,
  userRoles,
  updateInstituteInfos,
  permissions,
}) => {
  const instituteId = useSelector(state => state.auth.instituteCampusId)
  const dispatch = useDispatch()
  const [settingsForm] = Form.useForm()
  const [selectedTab, setSelectedTab] = useState('INSTITUTE')
  const [logoFile, setLogoFile] = useState(null)
  const [universityId, setUniversityId] = useState(
    instituteData ? instituteData?.institute?.universities?.id : ''
  )

  const [selectedCountry, setSelectedCountry] = useState({})
  const [selectedState, setSelectedState] = useState({})
  const [selectedCity, setSelectedCity] = useState({})
  const [socialMediaList, setSocialMediaList] = useState([])

  const [isFieldsChanged, setIsFieldsChanged] = useState(false)

  const [presentationFile, setPresentationFile] = useState(null)

  const [aboutWarning, setAboutWarning] = useState(false)

  const [updateLoading, setUpdateLoading] = useState(false)

  useEffect(() => {
    getInstituteInfo()
  }, [])

  useEffect(() => {
    dispatch(getUniversityList())
  }, [])

  const universityList = useSelector(state => state?.settings?.universityList)

  const initializeFormData = () => {
    setLogoFile(instituteData?.campusLogoUrl)
    setSocialMediaList(instituteData?.socialMedia || [])
    if (instituteData?.institutePresentationLink) {
      setPresentationFile({ url: instituteData?.institutePresentationLink })
    }
    settingsForm.setFieldsValue({
      universityName: instituteData?.institute?.universities?.name,
      campusLogoUrl: instituteData?.campusLogoUrl,
      instituteName: instituteData?.campusName?.trim(),
      websiteLink: instituteData?.website,
      college: instituteData?.collegeType,
      numberOfStudents: instituteData?.numberOfStudents,
      establishedYear: instituteData?.establishedYear
        ? moment(instituteData?.establishedYear, 'YYYY')
        : '',
      shortDescription: instituteData?.shortDescription?.trim(),
      aboutInstitute: instituteData?.longDescription,
      addressOne: instituteData?.addressLine1?.trim(),
      addressTwo: instituteData?.addressLine2?.trim(),
      instituteCountry: instituteData?.country,
      instituteState: instituteData?.state,
      instituteCity: instituteData?.city,
      instituteZipcode: instituteData?.postalCode,
      contactPersonName: instituteData?.contactPerson?.trim(),
      contactPersonRole: instituteData?.contactPersonRole,
      countryCode: instituteData?.countryCode,
      institutePhone: instituteData?.contactNumber,
      instituteEmail: instituteData?.contactEmail,
      instituteVideoLink: instituteData?.instituteVideoLink,
      companyPAN: instituteData?.pan,
      companyGST: instituteData?.gst,
    })
    instituteData?.socialMedia?.map((item, index) =>
      settingsForm.setFieldsValue({ [item?.media + index]: [item?.link] })
    )
  }

  useEffect(() => {
    initializeFormData()
  }, [instituteData])

  useEffect(() => {
    if (
      logoFile != instituteData?.campusLogoUrl ||
      (presentationFile?.url &&
        presentationFile?.url != instituteData?.institutePresentationLink)
    ) {
      onChangeFormFields()
    } else {
      setIsFieldsChanged(false)
    }
  }, [logoFile, presentationFile])

  const onChangeFormFields = () => {
    setIsFieldsChanged(true)

    if (
      !settingsForm.getFieldValue('aboutInstitute') ||
      settingsForm.getFieldValue('aboutInstitute') == '<p><br></p>'
    ) {
      setAboutWarning(true)
    } else {
      setAboutWarning(false)
    }
  }

  const onUniversityChange = (data, option) => {
    setUniversityId(option?.option?.id)
    settingsForm.setFieldsValue({ universityName: data })
  }

  const onSubmitFormData = async values => {
    let payload = {}
    setUpdateLoading(true)
    if (selectedTab === 'INSTITUTE') {
      payload = {
        instituteInfo: {
          campusLogoUrl: logoFile,
          campusName: values?.instituteName,
          website: values?.websiteLink,
          collegeType: values?.college,
          numberOfStudents: values?.numberOfStudents,
          establishedYear: values?.establishedYear
            ? getYear(values?.establishedYear)
            : '',
          shortDescription: values?.shortDescription,
          longDescription: values?.aboutInstitute,
          addressLine1: values?.addressOne,
          addressLine2: values?.addressTwo,
          city: selectedCity?.name,
          state: selectedState?.name,
          country: selectedCountry?.name,
          cityId: selectedCity?._id,
          stateId: selectedState?._id,
          countryId: selectedCountry?._id,
          postalCode: values?.instituteZipcode,
          countryCode: values?.countryCode,
          contactNumber: values?.institutePhone,
          contactEmail: values?.instituteEmail,
          contactPerson: values?.contactPersonName,
          contactPersonRole: values?.contactPersonRole || '',
        },
        institute: {
          universityId: universityId,
        },
      }
    }
    if (selectedTab === 'ADDINFO') {
      payload = {
        instituteInfo: {
          campusName: values?.instituteName,
        },
        additionalInfo: {
          institutePresentationLink: presentationFile?.url
            ? presentationFile?.url
            : null,
          instituteVideoLink: values?.instituteVideoLink
            ? values?.instituteVideoLink
            : null,
          socialMedia: socialMediaList
            ?.filter(item => item?.link)
            ?.map(data => {
              return {
                ...data,
                link: data?.link,
              }
            }),
        },
        institute: {
          universityId: universityId,
        },
      }
    }
    if (selectedTab === 'TAXINFO') {
      payload = {
        taxInfo: {
          pan: values?.companyPAN?.toUpperCase(),
          gst: values?.companyGST?.toUpperCase(),
        },
        institute: {
          campusName: values?.instituteName,
          universityId: universityId,
        },
      }
    }

    const { status } = await updateInstituteInfos(payload)

    if (status >= 200 && status <= 300) {
      dispatch(getInstituteDetails(instituteId))
      SuccessMessage('Updated Successfully')
      setIsFieldsChanged(false)
      setUpdateLoading(false)
    } else {
      setUpdateLoading(false)
    }
  }

  const cruds = permittedCruds(permissions, 'Settings')

  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading>Settings</TopHeading>
          {cruds?.includes('Edit') && (
            <Flex>
              <Button.Primary
                icon={<CheckedWhite />}
                height="32px"
                text={'Save Changes'}
                width={'144px'}
                form={'settingsForm'}
                htmlType="submit"
                loading={updateLoading}
                disabled={!isFieldsChanged}
              />
            </Flex>
          )}
        </TopHeader>
        <Form
          scrollToFirstError
          onFieldsChange={onChangeFormFields}
          onFinish={onSubmitFormData}
          id={'settingsForm'}
          form={settingsForm}
          layout="vertical"
        >
          <StyledTabs
            defaultActiveKey={selectedTab}
            activeKey={selectedTab}
            onChange={key => {
              if (isFieldsChanged) {
                confirm({
                  zIndex: '1001',
                  title: <p>Changes are not saved. Please save the changes!</p>,
                  okText: 'Ignore Changes',
                  okType: 'primary',
                  cancelText: 'Go Back',
                  onOk: () => {
                    initializeFormData()
                    setSelectedTab(key)
                    setIsFieldsChanged(false)
                  },
                  onCancel: () => {
                    const newSelectedTab = selectedTab
                    setSelectedTab(newSelectedTab)
                    setIsFieldsChanged(true)
                  },

                  width: 'fit-content',
                })
              } else {
                setSelectedTab(key)
                setIsFieldsChanged(false)
              }
            }}
          >
            <TabPane tab="Institute Info" key="INSTITUTE">
              <InstituteInfo
                file={logoFile}
                setFile={setLogoFile}
                instituteData={instituteData}
                getListOfCities={getListOfCities}
                getListOfStates={getListOfStates}
                getListOfCountries={getListOfCountries}
                settingsForm={settingsForm}
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                selectedState={selectedState}
                setSelectedState={setSelectedState}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                getUserRoles={getUserRoles}
                userRoles={userRoles}
                aboutWarning={aboutWarning}
                presentationFile={presentationFile}
                initializeFormData={initializeFormData}
                onUniversityChange={onUniversityChange}
                universityList={universityList}
              />
            </TabPane>
            <TabPane tab="Additional Info" key="ADDINFO">
              <AddtionalInfo
                instituteData={instituteData}
                socialMediaList={socialMediaList}
                setSocialMediaList={setSocialMediaList}
                presentationFile={presentationFile}
                setPresentationFile={setPresentationFile}
                onChangeFormFields={onChangeFormFields}
                settingsForm={settingsForm}
              />
            </TabPane>
            <TabPane tab="Tax Info" key="TAXINFO">
              <TaxInfo
                instituteData={instituteData}
                settingsForm={settingsForm}
                selectedTab={selectedTab}
              />
            </TabPane>
          </StyledTabs>
        </Form>
      </PaddedDiv>
    </SectionWrapper>
  )
}

export default Settings
